export default "__VITE_ASSET__Ifw9n0Jb__"